import { State } from "../state/state";

export const outputStatus = (channel: State.Channel, acFail: boolean) => {
  let msg = channel.latch
    ? "Manually Disabled (or FACP reset needed)"
    : "Manually Disabled";
  if (channel.facp) {
    return "FACP";
  } else if (acFail) {
    if (channel.bBackup) return channel.triggered ? "Battery Backup" : msg;
    else return channel.triggered ? "No Battery Backup" : msg;
  } else if (channel.triggered) {
    return "Normal";
  } else {
    return msg;
  }
};
